import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import BaseRateForm from './forms/BaseRateForm';
import { FormattedMessage } from 'react-intl';

const BaseRate = ({ listing, ...props }) => {
  const prices = get(listing, 'prices.0', '');
  return (
    <div>
      <h4><FormattedMessage id="hosting.base_rate.rate_heading" defaultMessage="Hourly base rate"/></h4>
      <p className="text-small text-gray-dark">
        <FormattedMessage id="hosting.base_rate.rate_text" defaultMessage="Hourly base rate on Peerspace refers to the minimum charge for booking a space for a single hour. Your payout will include this base rate, minus our standard Service Fee."/>
      </p>
      <div className="clearfix" />
      <div className="row margin-lg-top margin-md-bottom">
        <div className="col-xs-12">
          <BaseRateForm
            {...props}
            listing={listing}
            initialValues={{ prices }}
          />
        </div>
      </div>
      <div className="clearfix" />
      <hr />
    </div>
  );
};

BaseRate.propTypes = {
  listing: PropTypes.object.isRequired
};

export default BaseRate;
